import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
} from '@angular/core';
import type { FormControl } from '@angular/forms';

import { deepEqual } from 'fast-equals';
import { filter } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  DropdownComponent,
  DropdownItemComponent,
  IconComponent,
  NestedTemplateTriggerDirective,
} from '@core/user-interface-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';
import type { ViewFilterDef } from '@core/views-types';

import { ViewsAnalytics } from '../../../analytics/views-analytics';
import { FilterMultiselectComponent } from '../../../filters/advanced-filters/filter/filter-multiselect/filter-multiselect.component';
import { FiltersFormDataService } from '../../../filters/services/filters-form-data.service';

@Component({
  selector: 'recruitee-view-settings-pinned-filters',
  imports: [
    DropdownItemComponent,
    IconComponent,
    TranslatePipe,
    NestedTemplateTriggerDirective,
    FilterMultiselectComponent,
  ],
  templateUrl: './view-settings-pinned-filters.component.html',
  styleUrl: './view-settings-pinned-filters.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewSettingsPinnedFiltersComponent {
  public quickFiltersIdsControl = input.required<FormControl<string[] | null>>();

  public filterDefs: ViewFilterDef[] = [];
  public viewsAnalytics = inject(ViewsAnalytics);
  public mainDropdown = inject(DropdownComponent);
  public filtersFormDataService = inject(FiltersFormDataService);
  public pinnedFiltersCount = 0;

  private cdRef = inject(ChangeDetectorRef);
  private untilDestroyed = injectUntilDestroyed();

  public ngOnInit() {
    this.filtersFormDataService.quickFiltersFilterDefs$
      .pipe(
        filter(
          filterDefs =>
            !deepEqual(
              filterDefs.map(filterDef => filterDef.id),
              this.filterDefs.map(filterDef => filterDef.id),
            ),
        ),
        this.untilDestroyed,
      )
      .subscribe(filterDefs => {
        this.filterDefs = filterDefs;
        this.pinnedFiltersCount = filterDefs.length;
        this.cdRef.detectChanges();
      });
  }

  public onBackClick() {
    this.mainDropdown.prevTemplate();
  }

  public onFilterChange(filterDefs: ViewFilterDef[]) {
    const currentValue = filterDefs.map(filterDef => filterDef.id);
    this.quickFiltersIdsControl().setValue(currentValue);
    this.quickFiltersIdsControl().markAsDirty();
  }

  public onFilterRemove(filterDef: ViewFilterDef) {
    this.viewsAnalytics.quickFilterRemove({ filterId: filterDef.id });
  }

  public onFilterAdd(filterDef: ViewFilterDef) {
    this.viewsAnalytics.quickFilterAdd({ filterId: filterDef.id });
  }
}
